export default __webpack_public_path__ + "static/media/Group_199.22c3d1b0.svg";